import type { Order } from '@shared/types';

interface Props {
  orders: Order[];
}

const STRIPE_RATE = 0.029;
const STRIPE_FIXED = 0.30;

export default function FeeBreakdown({ orders }: Props) {
  const completed = orders.filter((o) => o.status === 'completed');
  if (completed.length === 0) return null;

  const grossRevenue = completed.reduce((sum, o) => sum + (o.verified_amount || o.expected_amount), 0);
  const estimatedFees = completed.reduce(
    (sum, o) => sum + (o.verified_amount || o.expected_amount) * STRIPE_RATE + STRIPE_FIXED,
    0,
  );
  const netRevenue = grossRevenue - estimatedFees;

  return (
    <div
      className="rounded p-5"
      style={{
        border: '1px solid var(--dash-border)',
        background: 'var(--dash-card)',
      }}
    >
      <div
        className="font-mono text-[10px] uppercase tracking-widest mb-4"
        style={{ color: 'var(--dash-text-dim)' }}
      >
        Fee Breakdown (estimated)
      </div>
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span
            className="font-sans text-xs"
            style={{ color: 'var(--dash-text-muted)' }}
          >
            Gross Revenue
          </span>
          <span
            className="font-mono text-xs"
            style={{ color: 'var(--dash-text-secondary)' }}
          >
            ${grossRevenue.toFixed(2)}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <span
            className="font-sans text-xs"
            style={{ color: 'var(--dash-text-muted)' }}
          >
            Stripe Fees (2.9% + $0.30)
          </span>
          <span className="font-mono text-xs text-red-400">-${estimatedFees.toFixed(2)}</span>
        </div>
        <div
          className="pt-3 flex items-center justify-between"
          style={{ borderTop: '1px solid var(--dash-border-light)' }}
        >
          <span
            className="font-sans text-xs font-medium"
            style={{ color: 'var(--dash-text-tertiary)' }}
          >
            Net Revenue
          </span>
          <span className="font-mono text-sm text-emerald-400">${netRevenue.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
}
